import { render, staticRenderFns } from "./addMovieCert.vue?vue&type=template&id=715522a1&scoped=true"
import script from "./addMovieCert.vue?vue&type=script&lang=js"
export * from "./addMovieCert.vue?vue&type=script&lang=js"
import style0 from "./addMovieCert.vue?vue&type=style&index=0&id=715522a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715522a1",
  null
  
)

export default component.exports